import { createApp } from 'vue';
import FaqSearch from './faq-search';

const app = createApp({});

app
    .mixin(vueGlobalMixin)
    .component('FaqSearch', FaqSearch)
    .mount('#js-search-vue-root');

const appMobile = createApp({});

appMobile
    .component('FaqSearch', FaqSearch)
    .mount('#js-search-modal-vue-root');

// menu left accordion
(()=>{
    const menu = document.querySelector('.j-faq__menu');
    const menuCategories = menu.querySelectorAll('.j-faq__menu-categories');
    const active = menu.querySelector('.j-faq__menu-body_type_is-active');

    active.style.maxHeight = `${active.scrollHeight}px`;
    active.classList.add('j-is-show');

    const eventClick = elem => {

        elem.addEventListener('click', () => {
            const header = elem.querySelector('.j-faq__menu-header');
            const body = elem.querySelector('.j-faq__menu-body');

            if (active) {
                active.style.maxHeight = null;
                active.classList.remove('j-faq__menu-body_type_is-active');
            }

            menu.querySelector('.faq__menu-header_type_is-active')
                .classList.remove('faq__menu-header_type_is-active');

            menu.querySelector('.j-is-show').style.maxHeight = null;

            menu.querySelector('.j-is-show')
                .classList.remove('j-is-show');

            header.classList.add('faq__menu-header_type_is-active');
            body.classList.add('j-is-show');

            body.style.maxHeight = `${body.scrollHeight}px`;
        });
    };


    for (let item of Array.from(menuCategories)) {
        eventClick(item)
    }
})();

// toggle menu left
(()=> {

    const body = document.querySelector('body');

    const toggleButton = document.querySelector('.j-faq__toggle-sidebar');
    const toggleBlock = document.querySelector('.j-toggle-block');



    toggleButton.addEventListener('click', ()=> {

        const modalBackdrop = document.querySelector('.modal-backdrop');

        const div = document.createElement('div');
        div.className = 'modal-backdrop fade';

        if (!modalBackdrop) {

            toggleBlock.classList.add('faq__toggle-block_type_is-active');
            toggleButton.classList.toggle('fi-bars')
            toggleButton.classList.toggle('fi-times');

            body.appendChild(div)
            setTimeout(()=> div.classList.add('show'), 100);

        } else {

            toggleBlock.classList.remove('faq__toggle-block_type_is-active');
            toggleButton.classList.toggle('fi-times');
            toggleButton.classList.toggle('fi-bars')

            modalBackdrop.classList.remove('show');
            setTimeout(()=> modalBackdrop.remove(), 500)

        }

    })

})();


// fixed position menu left
(() => {
    const menu = document.querySelector('.j-faq__menu');
    const menuCategories = menu.querySelectorAll('.j-faq__menu-categories');

    const scroll = (elem, i) => {

        setTimeout(()=> {
            const header = elem.querySelector('.j-faq__menu-header');
            const h =  header.clientHeight;

            menu.scrollTo({
                top: h * i,
                behavior: "smooth"
            });
        }, 100);

    };

    const eventClick = (elem, i) => {
        elem.addEventListener('click', () => scroll(elem, i));
    };

    menuCategories.forEach((elem, i) => {

        eventClick(elem, i);

        elem.querySelector('.j-faq__menu-body_type_is-active') && scroll(elem, i)
    })

})();